export default ({React,connect,CollapsePanel,ToolbarActions,StylePicker,slate})->

  { Block, Text } = slate

  class ResourceToolbar extends React.Component

    constructor:(props)->
      super(props)
      @state = {
        student:null
        hidefields:[]
        categories:[]
        resource_types:[]
        accesstypes:[]
        years:[]
        languages:[]
        perpage:null
        keyword:null
        organisation:null
        author:null
        fields:"title,author,resource_type,organisation,resource_date"
        allfields:"title,author,resource_type,organisation,resource_date"
      }

    componentDidMount:->
      fetch("/duocms/api/resourcecenter/resources/")
      .then (res)=> res.json() 
      .then (res)=>
        @setState({
          resource_types:res.data.fields.resource_type || []
          accesstypes:res.data.fields.accesstype || []
          years:res.data.fields.resource_years || []
          languages:res.data.fields.doc_language || []
          authors:res.data.fields.author || []
          organisations:res.data.fields.organisation || []
        })
        fetch("/duocms/api/resourcecenter/categories")
      .then (res)=> res.json() 
      .then (res)=>
        @setState({categories:res.data})
        @stateFromTag()

    componentDidUpdate:(prev_props,prev_state)->
      @stateFromTag() if prev_props.value.change().value.startBlock != @props.value.change().value.startBlock 

    stateFromTag:->
      tag = @getTag()
      return if !tag
      attrs = tag.data.toObject()
      @setState({student:attrs.student=="true"}) if attrs.student 
      @setState({hidefields:if attrs.hide then attrs.hide.split(",") else []})
      if attrs.category
        category = attrs.category.split(",")
        @setState({category:category[0]}) if category[0]
        @setState({subcategory:category[1]}) if category[1]
      @setState({accesstype:attrs.accesstype}) if attrs.accesstype
      @setState({language:attrs.language}) if attrs.language 
      @setState({perpage:attrs.perpage}) if attrs.perpage 
      @setState({fields:attrs.fields}) if attrs.fields 
      @setState({keyword:attrs.keyword}) if attrs.keyword 
      @setState({resourcetype:attrs.resourcetype}) if attrs.resourcetype 
      @setState({author:attrs.author}) if attrs.author?
      @setState({organisation:attrs.organisation}) if attrs.organisation?
      @setState({fromyear:attrs.fromyear}) if attrs.fromyear?
      @setState({toyear:attrs.toyear}) if attrs.toyear?
      
    getTag:->
      change = @props.value.change()
      tags = change.value.blocks.filter (node)-> node.type == "duoresource"
      return tags.get(0) if tags.size > 0

    updateEditor:()->
      tag = @getTag()
      return if !tag
      change = @props.value.change()
      attrs = {}
      attrs.student = if @state.student then "true" else null
      attrs.hide = if @state.hidefields.length then @state.hidefields.join(",") else null
      attrs.category = if @state.subcategory then @state.category+","+@state.subcategory else if @state.category then @state.category else null
      attrs.accesstype = if @state.accesstype then @state.accesstype else null
      attrs.resourcetype = if @state.resourcetype then @state.resourcetype else null
      attrs.language = if @state.language then @state.language else null
      attrs.perpage = if @state.perpage then @state.perpage else null
      attrs.fields = if @state.fields then @state.fields else null
      attrs.keyword = if @state.keyword? then @state.keyword else null
      attrs.author = if @state.author? then @state.author else null
      attrs.organisation = if @state.organisation? then @state.organisation else null
      attrs.fromyear = if @state.fromyear? then @state.fromyear else null
      attrs.toyear = if @state.toyear? then @state.toyear else null
      change.setNodeByKey(tag.key, {data: {...tag.data.toObject(),...attrs}}) 
      @props.setValue(change.value)

    updateFields:(field,checked)->
      fields = @state.fields.split(",")
      if checked && !fields.includes(field)
        @setState({fields: fields.concat(field).join(",")},()=> @updateEditor() )
      else if !checked && fields.includes(field)
        @setState({fields: fields.filter((f)=> f!=field).join(",") },()=> @updateEditor() )

    updateHide:(type,e)->
      hidefields = @state.hidefields
      if e.target.checked
        hidefields = [...new Set(hidefields.concat(type))]
      else
        hidefields = hidefields.filter (item)=> item!=type
      @setState({hidefields:hidefields},=> @updateEditor()) 
      
    render:->
      <CollapsePanel title="Resources Tools">
        <div>
          <div className="formhoriz">
            <div className="checkbox" style={{padding:"0px 2px"}}>
              <label>
                <input type="checkbox" checked={@state.student} onChange={(e)=>@setState({student:e.target.checked},=> @updateEditor()) } />
                Student Only?
              </label>
            </div>

            {["keyword","resourcetype","accesstype","author","organisation","advanced"].map (type) =>
              <div className="checkbox" style={{padding:"0px 2px"}}>
                <label>
                  <input type="checkbox" checked={@state.hidefields.includes(type)} onChange={@updateHide.bind(@,type)} />
                  Hide {type}?
                </label>
              </div>
            }

            <label>Keyword</label>
            <input className="form-control" placeholder="search term" value={@state.keyword}  onChange={(e)=>@setState({keyword:e.target.value},=> @updateEditor())} />
            
            <label>Resource Type</label>
            <select className="form-control" value={@state.resourcetype}  onChange={(e)=>@setState({resourcetype:e.target.value},=> @updateEditor())}>
              <option value="">Please Select</option>
              {@state.resource_types.map (val)=>
                <option value={val}>{val}</option>
              }
            </select>

            <label>Accesstype</label>
            <select className="form-control" value={@state.accesstype}  onChange={(e)=>@setState({accesstype:e.target.value},=> @updateEditor())}>
              <option value="">Please Select</option>
              {@state.accesstypes.map (val)=>
                <option value={val}>{val}</option>
              }
            </select>

            <label>Author</label>
            <select className="form-control" value={@state.author}  onChange={(e)=>@setState({author:e.target.value},=> @updateEditor())}>
              <option>Please Select</option>
              {@state.authors?.map (row)=>
                <option value={row.key}>{row.value}</option>
              }
            </select>

            <label>Organisation</label>
            <select className="form-control" value={@state.organisation}  onChange={(e)=>@setState({organisation:e.target.value},=> @updateEditor())}>
              <option>Please Select</option>
              {@state.organisations?.map (row)=>
                <option value={row.key}>{row.value}</option>
              }
            </select>

            <label>Main Category</label>
            <select className="form-control" value={@state.category}  onChange={(e)=>@setState({category:e.target.value},=> @updateEditor())}>
              <option value="">Please Select</option>
              {@state.categories.filter((c)=> c.parent_id == 0).map (c)=>
                <option value={c.id}>{c.name}</option>
              }
            </select>
            {if @state.category
              <React.Fragment>
                <label>Sub Category</label>
                <select className="form-control" value={@state.subcategory}  onChange={(e)=>@setState({subcategory:e.target.value},=> @updateEditor())}>
                  <option value="">Please Select</option>
                  {@state.categories.filter((c)=> +c.parent_id == +@state.category).map (c)=>
                    <option value={c.id}>{c.name}</option>
                  }
                </select>
              </React.Fragment>
            }

            <label>Language</label>
            <select className="form-control" value={@state.language}  onChange={(e)=>@setState({language:e.target.value},=> @updateEditor())}>
              <option value="">Please Select</option>
              {@state.languages.map (val)=>
                <option value={val}>{val}</option>
              }
            </select>

            <label>From Year</label>
            <select className="form-control" value={@state.fromyear}  onChange={(e)=>@setState({fromyear:e.target.value},=> @updateEditor())}>
              <option value="">Please Select</option>
              {@state.years.map (val)=>
                <option value={val}>{val}</option>
              }
            </select>

            <label>To Year</label>
            <select className="form-control" value={@state.toyear}  onChange={(e)=>@setState({toyear:e.target.value},=> @updateEditor())}>
              <option value="">Please Select</option>
              {@state.years.map (val)=>
                <option value={val}>{val}</option>
              }
            </select>

            

            <label>Per Page</label>
            <input className="form-control" type="number" value={@state.perpage} placeholder="10" onChange={(e)=>@setState({perpage:e.target.value},=> @updateEditor())} />
          </div> 
          <div className="formhoriz">
          <label>Chosen Fields</label>
          {@state.allfields.split(",").map (field)=>
             <div className="checkbox" style={{padding:"0px 2px"}}>
              <label>
                <input type="checkbox" checked={@state.fields.split(",").includes(field)} onChange={(e)=> @updateFields(field,e.target.checked)} />
                {field}
              </label>
            </div>
          }

          </div>

        </div>
      </CollapsePanel>

  connect(
    (state)->
      settings:state.settings
      toolbar_width:state.toolbar_width
      toolbars_active:state.toolbars_active
  )(ResourceToolbar)